import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, Suspense as _Suspense, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-900844fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-3" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "mb-0",
  ref: "bioEl"
}
const _hoisted_12 = { class: "clearfix mt-2" }
const _hoisted_13 = { class: "col-lg-9 mt-lg-0 mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon")
  const _component_spinner = _resolveComponent("spinner")

  return ($setup.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["TitleTag"], {
          title: '@' + $setup.user.username
        }, null, 8, ["title"]),
        _createVNode($setup["CanonicalRouteTag"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    class: "picture",
                    src: $setup.user.picture ? $setup.endpoints.asset('/upload/' + $setup.user.picture) : $setup.endpoints.asset('/img/default-user.png')
                  }, null, 8, _hoisted_7),
                  _createElementVNode("h4", _hoisted_8, "@" + _toDisplayString($setup.user.username), 1),
                  _createElementVNode("h4", _hoisted_9, [
                    _createVNode($setup["UserFlair"], {
                      flair: $setup.user.flair
                    }, null, 8, ["flair"])
                  ])
                ]),
                _hoisted_10,
                (!$setup.isEditingBio)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      ($setup.user.renderedBio)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, null, 512))
                        : _createCommentVNode("", true),
                      ($setup.currentUser && $setup.user.id == $setup.currentUser.id)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-info",
                            onClick: _cache[0] || (_cache[0] = $event => ($setup.isEditingBio = true))
                          }, [
                            _createVNode(_component_icon, {
                              class: "me-2",
                              icon: "pen-to-square"
                            }),
                            _createTextVNode("Set bio")
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode($setup["FitTextArea"], {
                        class: "form-control",
                        modelValue: $setup.newBio,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.newBio) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                          class: "btn btn-danger",
                          onClick: _cache[2] || (_cache[2] = $event => {$setup.isEditingBio = false; $setup.newBio = $setup.user.bio})
                        }, "Cancel"),
                        _createElementVNode("button", {
                          class: "btn btn-success float-end",
                          onClick: $setup.saveBio
                        }, "Save")
                      ])
                    ], 64))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(), _createBlock(_Suspense, { timeout: "0" }, {
              fallback: _withCtx(() => [
                _createVNode(_component_spinner)
              ]),
              default: _withCtx(() => [
                _createVNode($setup["HistoryFeed"], {
                  "user-id": $setup.user.id
                }, null, 8, ["user-id"])
              ]),
              _: 1
            }))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}